import React, { PropsWithChildren } from 'react';

import {
  TokenRefresherContextProvider,
  TokenRefresherContextValue,
} from './token-refresher-context';

interface TokenRefresherProviderProps {
  /**
   * Function that refreshes the access token and returns the new token.
   * If not provided, HTTP requests will not attempt token refresh on 401 errors.
   */
  refreshToken?: () => Promise<string>;
}

/**
 * Provider component that supplies token refresher functionality to HttpClient instances.
 * Wrap your app or components with this provider to enable automatic token refresh
 * when HTTP requests fail with 401 Unauthorized errors.
 */
export const TokenRefresherProvider: React.FC<
  PropsWithChildren<TokenRefresherProviderProps>
> = ({ children, refreshToken }) => {
  const contextValue: TokenRefresherContextValue = refreshToken
    ? { refreshToken }
    : null;

  return (
    <TokenRefresherContextProvider value={contextValue}>
      {children}
    </TokenRefresherContextProvider>
  );
};
